export const IMAGES = {
  heroAmbient:
    "https://static.prod-images.emergentagent.com/jobs/0f7eefeb-a60c-490c-9d70-c9a412af60e9/images/426bcd7a178b69417bbe47daca77a1e3b97f150b4eef33557db5793e9fe0472a.jpeg",
  productSpotlight:
    "https://static.prod-images.emergentagent.com/jobs/0f7eefeb-a60c-490c-9d70-c9a412af60e9/images/624bb08cb15d1447c465b9c9d45452e0cd1160c6804fd33589a8b5e4980eb35b.jpeg",
  ecosystemOrb:
    "https://static.prod-images.emergentagent.com/jobs/0f7eefeb-a60c-490c-9d70-c9a412af60e9/images/06d8a68cccce6f1c49d78a463fe67c2ca50ed0982455912725f606e21492b655.jpeg",
  heroPlate:
    "https://static.prod-images.emergentagent.com/jobs/0f7eefeb-a60c-490c-9d70-c9a412af60e9/images/5d7bc68a6268acb6331481f6496e0e3bced27ad180858d4cb3890004e83d490a.jpeg",
  orbA:
    "https://static.prod-images.emergentagent.com/jobs/0f7eefeb-a60c-490c-9d70-c9a412af60e9/images/c0e6285decfde1a51f0278e3f91257bfbe32c0ad6393ae8543ce11add98127b1.jpeg",
  earthHorizon:
    "https://static.prod-images.emergentagent.com/jobs/0f7eefeb-a60c-490c-9d70-c9a412af60e9/images/37da155cdc0c39d96fa6c9055490352b334ca5b43b3f4ef2e8ad907345a311b4.jpeg",
  capitalisVisual:
    "https://static.prod-images.emergentagent.com/jobs/0f7eefeb-a60c-490c-9d70-c9a412af60e9/images/e13ba01f4a5e5892a31a917ba76bf74b31ac60184398da063053bb27e4407957.jpeg",
  creditVisual:
    "https://static.prod-images.emergentagent.com/jobs/0f7eefeb-a60c-490c-9d70-c9a412af60e9/images/ed8d34b9210114428cbcab5434a77760039379532a2e19477f19ac266f9c5379.jpeg",
  arcaosVisual:
    "https://static.prod-images.emergentagent.com/jobs/0f7eefeb-a60c-490c-9d70-c9a412af60e9/images/96e60958dded0ee62483dbe770496ab85dfd16434b699ac383b8cc84321416a3.jpeg",
};

// ArcaCentum Credit public landing route (update to production URL when connected).
export const CREDIT_URL = "/credit";

export const CONTACT_EMAIL = "support@arcacentum.com";

export const NAV_LINKS = [
  { label: "Products", href: "#products" },
  { label: "Vision", href: "#vision" },
  { label: "Ecosystem", href: "#ecosystem" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];
